// extracted by mini-css-extract-plugin
export default {"exportButton":"Recipients_exportButton__LucjE"};